import React from "react";
import { useTranslation } from "react-i18next";
import TopBar from "../../components/TopBar";
import Footer from "../../components/Footer";
import Product from "../../components/home/Product";
import More from "../about/components/more";
import { useNavigate } from "react-router";

const ComponentName: React.FC = () => {
  const { t } = useTranslation();
  const [see, setSee] = React.useState(false)
  const navigate = useNavigate()
  return (
    <div className="">
      <TopBar />
      <div className=" w-[1200px] mx-auto h5:w-full">
        <div className="my-[30px] flex items-center text-[#181512] text-[16px] h5:px-16">
          <div className="text-[#595959] text-[16px] mr-4 cursor-pointer" onClick={() => navigate('/')}>首頁</div>
          /
          <div className="text-[#181512] text-[16px] ml-4">個人資料保護政策</div>
        </div>
        <br />

        <div className="text-[#181512] text-[44px] font-bold text-center h5:px-16">個人資料保護政策</div>
        <br />
        <div className="h5:px-16">
          <div className="text-[#595959] text-[16px] mb-[30px]"> 詩肯股份有限公司(以下簡稱詩肯或本公司)非常重視消費者的隱私權且對於消費者資料的蒐集、處理及利用均遵守「個人資料保護法」之規範，詩肯依法就您的個人資料權益進行告知如下：</div>
          <hr />
          <br /><br />
          <div className="text-[#595959] text-[16px] mb-[30px]">
            一、隱私權保護政策的適用範圍
            <br /><br />
            一、個人資料之安全：
            <br /><br />
            保護消費者的個人隱私是詩肯重要的經營理念，在未經消費者同意之下，本公司不會將消費者的個人資料提供予任何與業務無關之第三人。
            <br /><br />
            二、蒐集之目的及方式：
            <br /><br />
            1.行銷（法定特定目的項目編號為040）
            <br /><br />
            2.消費者管理與服務（法定特定目的項目編號為090）
            <br /><br />
            3.網路購物及其他電子商務服務（法定特定目的項目編號為148）
            <br /><br />
            4.調查、統計與研究分析（法定特定目的項目編號為157）
            <br /><br />
            5.契約、類似契約或其他法律關係事務（法定特定目的項目編號為069）
            <br /><br />
            6.信用卡業務（法定特定目的項目編號為067）
            <br /><br />
            詩肯將藉由註冊會員之過程或進行交易之過程蒐集個人資料。
            <br /><br />
            三、蒐集之個人資料類別：
            <br /><br />
            詩肯蒐集的個人資料包括
            <br /><br />
            1.當消費者註冊成為詩肯會員時，詩肯會請消費者提供基本資料，例如：姓名、地址、聯絡電話、電子信箱及其他由消費者主動提供之資料等。
            <br /><br />
            2.當消費者指定商品配送服務時，詩肯會請消費者提供配送資料，例如：收件人之姓名、聯絡電話、收貨地址及其他必要配送聯絡資料。
            <br /><br />
            3.當消費者有實際消費行為時，詩肯會留存消費者的帳務資料。
            <br /><br />
            4.詩肯基於市場分析、贈獎活動、會員權益通知、或提供現在或未來詩肯官網衍生之其他服務
            <br /><br />
            或附隨以上各項服務，為進行必要作業所需，將合法利用及使用消費者已提供之相關資料。
            <br /><br />
            5.於一般瀏覽時，伺服器會自行記錄相關行徑，包括消費者使用連線設備的IP位址、使用時間、使用的瀏覽器、瀏覽及點選之資料記錄等，做為我們增進網站服務的參考依據，此記錄為本公司內部應用，決不對外公佈。
            <br /><br />
            6.為提供精確的服務，我們會將收集的問卷調查內容進行統計與分析，分析結果將以統計數據或說明文字呈現，除供內部研究外，我們會視需要公佈統計數據及說明文字，但不涉及特定個人之資料。
            <br /><br />
            四、利用期間、地區、對象及方式：
            <br /><br />
            1.期間：本公司營運期間及依法令或契約規範應保存個人資料之期間。
            <br /><br />
            2.地區：本公司營運地區。
            <br /><br />
            3.利用對象及方式：詩肯所取得的消費者個人資料，僅提供予詩肯內部及詩肯所委任處理營業相關事務之第三人(例如：金融機構、合作廠商、物流商、行銷廣宣、分析等服務提供者)，並依照前述蒐集目的之範圍內進行相關作業之必要運用或揭露會員個人資料。除非另有法令規範，或另行取得消費者同意，否則詩肯不會向前述以外之第三人揭露消費者個人資料。
            <br /><br />
            4.詩肯提供資料予其他第三人之原因，除經過消費者本人同意，尚有可能基於以下情形：
            <br /><br />
            (1)於上開特定目的範圍作業利用之必要
            <br /><br />
            (2)合於個人資料保護法第20條規定為特定目的外之利用
            <br /><br />
            (3)基於法律之規定或受司法機關與政府機關基於法定程序之要求
            <br /><br />
            (4)在緊急情況下為維護第三人之合法權益
            <br /><br />
            (5)為維護消費者服務系統的正常運作
            <br /><br />
            (6)消費者透過本服務購物、兌換贈品、參加抽獎活動等因而產生的金/物流之必要資訊
            <br /><br />
            5.利用個人資料之方式例示如下：
            <br /><br />
            (1)以消費者身份使用詩肯提供之各項服務時，於頁面中自動顯示消費者資訊。
            <br /><br />
            (2)為遂行交易行為：消費者對商品或勞務為預約、下標、購買、參與贈獎等之活動或從事其他交易時，關於商品配送、勞務提供、價金給付、相關售後服務及其他遂行交易所必要之業務。
            <br /><br />
            (3)宣傳廣告或行銷活動等：透過電子郵件、郵件、電話等提供消費者各種資訊。將消費者所瀏覽之內容或廣告，依消費者之個人屬性或購買紀錄、詩肯網站之瀏覽紀錄等項目，進行個人化作業、消費者使用服務之分析、新服務之開發或既有服務之改善等。
            <br /><br />
            (4)回覆消費者之詢問：針對消費者透過電子郵件、郵件、電話或其他任何直接、間接聯絡方式向詩肯所提出之詢問事項進行回覆。
            <br /><br />
            (5)其他業務附隨之事項：附隨於上述(1)至(4)之利用目的而為詩肯提供服務所必要之使用。
            <br /><br />
            (6)對於個別服務提供者之資訊提供：消費者對詩肯以外之服務提供者之商品或勞務為預約、下標、購買、參加贈獎活動或申請其他交易時，詩肯於該交易所必要之範圍內，得將消費者之個人資料檔案提供予服務提供者，並由服務提供者負責管理該個人資料檔案。詩肯將以規約課予服務提供者依法令與保障消費者隱私權之原則處理個人資料之義務，但無法保證服務提供者會必然遵守，若服務提供者未遵守保護消費者隱私權之相關規範，詩肯亦不負擔連帶責任或任何法律責任。詳細內容與權利義務，請向個別服務提供者洽詢。
            <br /><br />
            (7)其他：提供個別服務時，詩肯亦可能於上述規定之目的以外，利用個人資料。此時將在該個別服務之網頁載明其要旨。
            <br /><br />
            五、消費者就個人資料之權利：
            <br /><br />
            詩肯所蒐集個人資料之當事人，依個人資料保護法得對詩肯行使以下權利：
            1.消費者有權請求查詢、閱覽其個人資料或請求提供複製本。但本公司依法得酌收必要的成本
            <br /><br />
            費用。
            <br /><br />
            2.消費者有權向本公司補充或更正其個人資料，惟應提出適當之證明文件。
            <br /><br />
            3.消費者有權請求刪除、停止蒐集、處理或利用其個人資料，惟此將可能造成消費者無法享有完整服務。
            <br /><br />
            4.如欲行使上述各項權利，其行使方式依法令及本公司相關規定，可洽本公司各門市辦理、
            <br /><br />
            直撥客服電話：0800-358088，或寄送電子郵件至客服信箱：hello@scanteak.com.tw
            <br /><br />
            聯絡申請。但如因本公司執行職務或業務所必須或受其他法律所規範者，本公司得拒絕消費者行使上述各項權利之申請。
            <br /><br />
            六、資料完整性或正確性之權益影響：
            <br /><br />
            若消費者不同意提供個人資料或未提供完整及正確之個人資料，消費者可能因此無法享受完整服務或完成相關交易(例如：享有各項優惠服務、成為會員或收到最新資訊等)，本公司保留個別判斷是否同意提供該等相關服務或完成相關交易之權利。如所提供之個人資料有誤或虛偽不實者，消費者亦不受此聲明之保護且需自負相關法律責任。
            <br /><br />
            七、隱私權保護政策修訂
            <br /><br />
            隨著市場環境的改變本公司將會於必要時持續修訂網站政策。消費者如對於詩肯網站隱私權聲明或與個人資料有關之事項有任何疑問，可來電客服或寄送電子郵件至客服信箱：hello@scanteak.com.tw。
            <br /><br /> <br /><br /> <br /><br />
          </div>
        </div>


      </div>

      <Footer />
    </div>
  );
};

export default ComponentName;
